import { useContext as e } from "react";
import { LocaleContext as s } from "../components/Context/index.js";
import { isLocalizationSchemaKey as n } from "../types/localizationSchema.js";
const m = () => {
  const o = e(s);
  if (!o)
    throw new Error("useTranslation must be used within a KCCLocaleProvider");
  const a = (t) => n(t) ? r(t) : t, r = (t) => o.translations[t] || t;
  return { t: r, safeTranslate: a, tryTranslate: (t) => n(t) ? r(t) : null };
};
export {
  m as useTranslation
};
